import React from 'react';
import { OrderedMap } from 'immutable';
import Workspace from '@repo/utils/models/Workspace';
import { ID } from '@repo/utils/types';

export interface WorkspaceContextSchema {
  activeWorkspace: Workspace | null;
  workspaces: OrderedMap<ID, Workspace>;
  userIsAdmin: boolean;
  updateActiveWorkspace: (updates: Partial<Workspace>) => void;
  updateWorkspaces: (updated: OrderedMap<ID, Workspace>) => void;
  isMultiPlayer: boolean;
}

// @ts-ignore - we pass undefined instead of a default ctx
export const WorkspaceContext = React.createContext<WorkspaceContextSchema>();
